import { render, staticRenderFns } from "./logsig.vue?vue&type=template&id=2d746540&scoped=true&"
import script from "./logsig.vue?vue&type=script&lang=js&"
export * from "./logsig.vue?vue&type=script&lang=js&"
import style0 from "./logsig.vue?vue&type=style&index=0&id=2d746540&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d746540",
  null
  
)

export default component.exports